import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './NotificationBubble.scss'

const NotificationBubble = props => {
	if (props.amount > 0)
		return (
			<div styleName="bubble">
				{props.amount > 9 ? '+9' : props.amount}
			</div>
		)
}

NotificationBubble.propTypes = {
	amount: React.PropTypes.number
}

export default CSSModules(NotificationBubble, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/NotificationBubble/NotificationBubble.js